"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _realtimePlayer = _interopRequireDefault(require("promo-js/lib/video-player/realtime-player"));

var _ratio = _interopRequireDefault(require("promo-js/lib/video-player/shapes/ratio.shape"));

var _videoPlayer = _interopRequireDefault(require("promo-js/lib/video-player"));

var _videoControls = _interopRequireDefault(require("promo-js/lib/video-player/video-controls"));

var _genericPopup = _interopRequireDefault(require("../generic-popup/generic-popup"));

var _genericPopupThemes = _interopRequireDefault(require("../generic-popup/generic-popup-themes"));

const VideoPopup = props => {
  const {
    videoUrl,
    videoData,
    onClose,
    ratio,
    children,
    className
  } = props;
  const url = videoUrl || btoa(videoData);
  const Player = videoUrl ? _videoPlayer.default : _realtimePlayer.default;
  return /*#__PURE__*/_react.default.createElement(_genericPopup.default, {
    onClose: onClose,
    className: (0, _classnames.default)('video-popup', className),
    theme: _genericPopupThemes.default.WHITE
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "video-popup__video-container"
  }, /*#__PURE__*/_react.default.createElement(Player, {
    videoUrl: url,
    ratio: ratio,
    knownAxis: "height",
    autoplay: true,
    hasShare: false
  }, /*#__PURE__*/_react.default.createElement(_videoControls.default, {
    set: "desktop",
    hasSeekPreview: false
  }))), children);
};

VideoPopup.propTypes = {
  videoUrl: _propTypes.default.string,
  videoData: _propTypes.default.string,
  onClose: _propTypes.default.func.isRequired,
  ratio: _ratio.default.isRequired,
  children: _propTypes.default.node,
  className: _propTypes.default.string
};
VideoPopup.defaultProps = {
  videoUrl: null,
  videoData: null,
  children: null,
  className: ''
};
var _default = VideoPopup;
exports.default = _default;